import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { userSignOut } from "actions/Auth";
import CustomRadioButton from "components/CustomRadioButton/CustomRadioButton";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TransverseLoading } from "react-loadingg";
import { useDispatch } from "react-redux";
import Num2persian from "util/number2Persian";
import { getAxios } from "../../api/Axios";
import { balanceApi, increaseBalanceApi } from "../../api/Urls";
import useOutsideClick from "../../hooks/useOutsideClick";
import classes from "./Header.module.scss";
import PersianPrice from "./PersianPrice";
import WalletDropdown from "./WalletDropdown/WalletDropdown";
import toWord from "util/toWord";
import { useSnackbar } from "notistack";

const Balance = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [balance, setBalance] = useState(0);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);
  const wrapperBalanceRef = useRef(null);
  const [toggle, setToggle] = useOutsideClick(wrapperBalanceRef);

  const handleChangeRadio = (event) => {
    setAmount(event.target.value);
  };

  useEffect(() => {
    getAxios(balanceApi)
      .then((d) => {
        setBalance(d?.data?.balance);
      })
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
        if (err?.response?.status === 401) {
          dispatch(userSignOut());
        }
      });
  }, []);

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_self", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
    handleRequestClose();
  };

  const handleRequestClose = () => {
    setOpen(false);
    setAmount("");
    setLoading(false);
  };

  const clickHandler = async () => {
    setLoading(true);
    if (!amount) {
      setError(t("header.insert_amount"));
      setLoading(false);
      setOpenSnack(true);
    } else {
      const paymentUrl = `${increaseBalanceApi}/${localStorage.getItem(
        "uuid"
      )}/${amount}`;
      openInNewTab(paymentUrl);
    }
  };

  const handleSnackbar = () => {
    setOpenSnack(false);
    setError("");
  };

  const handleToggleDropdown = () => {
    setToggle(!toggle);
  };

  return (
    <div
      className={classes.showHeader}
      ref={wrapperBalanceRef}
      style={{ position: "relative", marginRight: "10px" }}
    >
      <div
        className={
          toggle
            ? `${classes.headerButtonOpen} ${classes.profileAndBalance}`
            : `${classes.headerButton} ${classes.profileAndBalance}`
        }
        onClick={() => {
          handleToggleDropdown();
          // setOpen(true);
        }}
      >
        <span
          className={classes.profileTitle}
          style={{
            marginRight: 10,
            fontWeight: "bold",
            fontSize: 15,
          }}
        >
          {i18n.language === "fa" ? <PersianPrice number={balance} /> : balance}
        </span>
        <span
          className={classes.profileTitle}
          style={{
            marginRight: 5,
            marginLeft: 10,
            fontSize: 10,
          }}
        >
          {t("header.rial")}
        </span>
        <span>
          {toggle ? (
            <ExpandLessIcon className={classes.icons} fontSize="small" />
          ) : (
            <ExpandMoreIcon className={classes.icons} fontSize="small" />
          )}
        </span>
      </div>
      <WalletDropdown
        toggle={toggle}
        setOpen={setOpen}
        handleToggleDropdown={handleToggleDropdown}
      />
      <Dialog
        open={open}
        onClose={handleRequestClose}
        fullWidth={true}
        maxWidth={"sm"}
        className={classes.dialogRoot}
      >
        <div className="text-center" style={{ maxWidth: "100%", padding: 20 }}>
          <div className="mb-4">
            <h2>{t("header.charge_account")}</h2>
          </div>
          <div className="login-form">
            <div className={classes.outlinedInput}>
              <FormControl variant="outlined">
                <OutlinedInput
                  id="outlined-adornment-weight"
                  type="number"
                  value={amount}
                  onChange={(event) => setAmount(event.target.value)}
                  placeholder={i18n.language === "fa" ? "۱,۰۰۰" : "1000"}
                  endAdornment={
                    <InputAdornment position="end">
                      {t("header.rial")}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div
              style={{
                padding: "1.5em 0",
                display: "flex",
                justifyContent: "space-around",
                flexDirection: "row-reverse",
              }}
            >
              <CustomRadioButton
                values={[
                  {
                    label: i18n.language === "fa" ? "۱،۰۰۰،۰۰۰ ريال" : "100 $",
                    value: i18n.language === "fa" ? "1000000" : "100",
                  },
                  {
                    label: i18n.language === "fa" ? "۵،۰۰۰،۰۰۰ ريال" : "200 $",
                    value: i18n.language === "fa" ? "5000000" : "200",
                  },
                  {
                    label: i18n.language === "fa" ? "۱۰،۰۰۰،۰۰۰ ريال" : "500 $",
                    value: i18n.language === "fa" ? "10000000" : "500",
                  },
                ]}
                name="amount"
                handleChangeRadio={handleChangeRadio}
              />
            </div>
            <div>
              <h2>
                {i18n.language === "fa"
                  ? Num2persian(amount.slice(0, -1))
                  : toWord(amount || 0)}{" "}
                {t("header.toman")}
              </h2>
            </div>
            <div className={`mt-4 mb-2 ${classes.buttonRoot}`}>
              <Button
                variant="contained"
                className="btn btn-primary jr-btn-uptin "
                onClick={clickHandler}
              >
                {loading ? <TransverseLoading /> : t("header.payment")}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={3000}
        open={openSnack}
        className="add-user-snackbar"
        onClose={handleSnackbar}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={<span id="message-id">{error}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={handleSnackbar}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </div>
  );
};

export default Balance;
